<!--begin::Logo-->
<app-sidebar-logo
  class="px-6 app-sidebar-logo"
  id="kt_app_sidebar_logo"
  [toggleButtonClass]="toggleButtonClass"
  [toggleEnabled]="toggleEnabled"
  [toggleType]="toggleType"
  [toggleState]="toggleState"
  (toggleHover)="onToggleHover($event)"
  (toggleChange)="onToggleChange($event)"
  (mouseenter)="onSideLogoHover($event, true)"
  (mouseleave)="onSideLogoHover($event, false)"
>
</app-sidebar-logo>
<!--end::Logo-->

<!--begin::sidebar menu-->
<app-sidebar-menu
  class="overflow-hidden app-sidebar-menu flex-column-fluid"
  [hover]="isHover"
  [toggle]="isToggle"
>
</app-sidebar-menu>
<!--end::sidebar menu-->

<!--begin::Footer-->
<div
  class="px-6 pb-6 app-sidebar-version flex-column-auto"
  id="kt_app_sidebar_footer"
  aria-label="Application version"
>
  <span>{{ appVersion }}</span>
</div>
<!-- <app-sidebar-footer
  class="px-6 pt-2 pb-6 app-sidebar-footer flex-column-auto"
  id="kt_app_sidebar_footer"
>
</app-sidebar-footer> -->
<!--end::Footer-->
